export function getView(is_admin, app_company_status) {
  if (!is_admin) return 'No'
  return app_company_status === 'granted' ? 'Manage' : 'Install'
}
